import { IconTrash } from "@tabler/icons-react"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { ActionIcon, DateCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useDeleteMagicLinkMutation } from "./hooks"

const columnHelper = createColumnHelper<AdminResponses.MagicLinkLogs>()
export const useMagicLinkColumns =
  (): ColumnDef<AdminResponses.MagicLinkLogs>[] => {
    const { mutate: deleteMagicLink } = useDeleteMagicLinkMutation()

    return useMemo<ColumnDef<AdminResponses.MagicLinkLogs, any>[]>(
      () => [
        columnHelper.accessor("id", {
          header: "ID",
          enableSorting: false,
          cell: (info) => <TextCell value={info.getValue()} />,
        }),
        columnHelper.accessor("user.email", {
          header: "User Email",
          enableSorting: false,
          cell: (info) => <TextCell value={info.getValue()} />,
        }),
        columnHelper.accessor("type", {
          header: "Type",
          enableSorting: false,
          cell: (info) => <TextCell value={info.getValue()} />,
        }),
        columnHelper.accessor("createdAt", {
          header: "createdAt",
          cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        }),
        columnHelper.accessor("updatedAt", {
          header: "updatedAt",
          cell: (info) => <DateCell date={info.getValue()} format="lll" />,
        }),
        columnHelper.accessor("deletedAt", {
          header: "Deleted",
          id: "action-cell-deleted",
          enableSorting: false,
          cell: ({ row, getValue }) => {
            const deletedAt = getValue()
            if (deletedAt) return <TextCell value="TRUE" />
            return (
              <ActionIcon
                icon={<IconTrash />}
                onClick={() => deleteMagicLink(row.original.id)}
              />
            )
          },
        }),
      ],
      [deleteMagicLink]
    )
  }
